import { useCallback } from "react";

import styled from "styled-components";

import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";

import useWidth from "Utilities/Hooks/useWidth";

import { useMemberToobarContext } from "../../MemberToolbarState";
import { contentKeys } from "../../contentKeys";
import { ButtonWrapper } from "../shared";

import ButtonDisplay from "./ButtonDisplay";
import { useIsActive } from "./stateHooks";

const ContactButton = (props) => {
  const { contactButtonRef, message } = useMemberToobarContext();
  const isActive = useIsActive();

  const buttonWidth = useWidth(contactButtonRef);

  const { setActiveContentKey } = useMemberToolbarStore();

  const onClick = useCallback(() => {
    if (isActive) {
      setActiveContentKey(contentKeys.nothing);
    } else if (!message) setActiveContentKey(contentKeys.contact);
    else setActiveContentKey(contentKeys.form);
  }, [isActive, setActiveContentKey, message]);

  return (
    <ButtonContainer $minWidth={buttonWidth}>
      <ButtonWrapper
        DisplayComponent={ButtonDisplay}
        isActive={isActive || Boolean(message)}
        ref={contactButtonRef}
        onClick={onClick}
        {...props}
        data-cy="MemberToolbar_ContactButton"
      />
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  text-align: right;
  height: 24px;
  min-width: ${({ $buttonWidth }) => $buttonWidth || 40}px;
`;

export default ContactButton;
